import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";
import _assertThisInitialized from "@babel/runtime/helpers/esm/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import { createElement, Fragment } from "@wordpress/element";

/**
 * External dependencies
 */
// Needed to initialise the default datepicker styles.
// See: https://github.com/airbnb/react-dates#initialize
import 'react-dates/initialize';
/**
 * WordPress dependencies
 */

import { Component } from '@wordpress/element';
import { __, _x } from '@wordpress/i18n';
/**
 * Internal dependencies
 */

import Button from '../button';
import { default as DatePicker } from './date';
import { default as TimePicker } from './time';
export { DatePicker, TimePicker };
export var DateTimePicker =
/*#__PURE__*/
function (_Component) {
  _inherits(DateTimePicker, _Component);

  function DateTimePicker() {
    var _this;

    _classCallCheck(this, DateTimePicker);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(DateTimePicker).apply(this, arguments));
    _this.state = {
      calendarHelpIsVisible: false
    };
    _this.onClickDescriptionToggle = _this.onClickDescriptionToggle.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(DateTimePicker, [{
    key: "onClickDescriptionToggle",
    value: function onClickDescriptionToggle() {
      this.setState({
        calendarHelpIsVisible: !this.state.calendarHelpIsVisible
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          currentDate = _this$props.currentDate,
          is12Hour = _this$props.is12Hour,
          onChange = _this$props.onChange;
      return createElement("div", {
        className: "components-datetime"
      }, !this.state.calendarHelpIsVisible && createElement(Fragment, null, createElement(TimePicker, {
        currentTime: currentDate,
        onChange: onChange,
        is12Hour: is12Hour
      }), createElement(DatePicker, {
        currentDate: currentDate,
        onChange: onChange
      })), this.state.calendarHelpIsVisible && createElement(Fragment, null, createElement("div", {
        className: "components-datetime__calendar-help"
      }, createElement("h4", null, __('Click to Select')), createElement("ul", null, createElement("li", null, __('Click the right or left arrows to select other months in the past or the future.')), createElement("li", null, __('Click the desired day to select it.'))), createElement("h4", null, __('Navigating with a keyboard')), createElement("ul", null, createElement("li", null, createElement("abbr", {
        "aria-label": _x('Enter', 'keyboard button')
      }, "\u21B5"), ' '
      /* JSX removes whitespace, but a space is required for screen readers. */
      , createElement("span", null, __('Select the date in focus.'))), createElement("li", null, createElement("abbr", {
        "aria-label": __('Left and Right Arrows')
      }, "\u2190/\u2192"), ' '
      /* JSX removes whitespace, but a space is required for screen readers. */
      , __('Move backward (left) or forward (right) by one day.')), createElement("li", null, createElement("abbr", {
        "aria-label": __('Up and Down Arrows')
      }, "\u2191/\u2193"), ' '
      /* JSX removes whitespace, but a space is required for screen readers. */
      , __('Move backward (up) or forward (down) by one week.')), createElement("li", null, createElement("abbr", {
        "aria-label": __('Page Up and Page Down')
      }, __('PgUp/PgDn')), ' '
      /* JSX removes whitespace, but a space is required for screen readers. */
      , __('Move backward (PgUp) or forward (PgDn) by one month.')), createElement("li", null, createElement("abbr", {
        "aria-label": __('Home and End')
      }, __('Home/End')), ' '
      /* JSX removes whitespace, but a space is required for screen readers. */
      , __('Go to the first (home) or last (end) day of a week.'))), createElement(Button, {
        isSmall: true,
        onClick: this.onClickDescriptionToggle
      }, __('Close')))), !this.state.calendarHelpIsVisible && createElement(Button, {
        className: "components-datetime__date-help-button",
        isLink: true,
        onClick: this.onClickDescriptionToggle
      }, __('Calendar Help')));
    }
  }]);

  return DateTimePicker;
}(Component);
//# sourceMappingURL=index.js.map